import {useMutation, useQueryClient} from '@tanstack/react-query'

import type {LoadEntryInput} from 'src/jobs/loads/schemas'

import {recordDriverLoads} from './api'
import {driverJobKeys} from './query-keys'

export function useRecordDriverLoads(jobId: string, accessToken: string) {
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: (input: LoadEntryInput) => recordDriverLoads(jobId, accessToken, input),
        onSuccess: () => {
            void queryClient.invalidateQueries({queryKey: driverJobKeys.detail(jobId, accessToken)})
        },
    })
}
